import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getPickedNLCItems,
  getVendorsByEvent,
} from '../../services/internal/vendor-grid-service'
import { exportToExcel } from '../../services/internal/vendor-grid-service'

export const fetchVendorsByEvent = createAsyncThunk(
  'vendors/fetchVendorsByEvent',
  async (data: { eventId; page; perPage }) => {
    const { eventId, page, perPage } = data
    const res = await getVendorsByEvent({
      eventId,
      page,
      perPage,
    })
    const response = {}
    response[eventId] = res.data
    return response
  },
)

export const exportVendorGridToExcelAction = createAsyncThunk(
  'vendors/exportVendorGridToExcel',
  async (data: { fileName; exportTableData }) => {
    const { fileName, exportTableData } = data
    return await exportToExcel({ fileName, exportTableData })
  },
)

export const fetchPickedNLCItems = createAsyncThunk(
  'vendors/fetchPickedNLCItems',
  async (data: { eventId; page; perPage }) => {
    const { eventId, page, perPage } = data
    return await getPickedNLCItems({
      eventId,
      page,
      perPage,
    })
  },
)

const initialState = {
  vendorsByEventId: {},
  isFetchingVendors: false,
  isDownloading: false,
  bids: {},
  bpIds: [],
  isFetchingPickedNLCItems: false,
  pickedNLCItems: [],
  pickedNLCItemsCount: 0,
}

const vendorsSlice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // fetchVendorsByEvent
      .addCase(fetchVendorsByEvent.pending, state => {
        state.isFetchingVendors = true
      })
      .addCase(fetchVendorsByEvent.fulfilled, (state, action) => {
        let bpIds = []
        const bids = {}
        Object.entries(action.payload).forEach(([_, value]: [string, any]) => {
          value.bids.map(
            vendor =>
              (bids[vendor.id] = {
                name: vendor.name,
                bp_id: vendor.bp_id,
                round_start_time: vendor.round_start_time,
              }),
          )
          bpIds = value.bids.map(vendor => vendor.bp_id)
        })
        const vendorsByEventIdTemp = {
          ...state.vendorsByEventId,
          ...action.payload,
        }
        return {
          ...state,
          isFetchingVendors: false,
          vendorsByEventId: vendorsByEventIdTemp,
          bids: bids,
          bpIds: bpIds,
        }
      })
      .addCase(fetchVendorsByEvent.rejected, state => {
        return {
          ...state,
          isFetchingVendors: false,
          vendorsByEventId: {},
          bids: {},
          bpIds: [],
        }
      })

      // exportVendorGridToExcelAction
      .addCase(exportVendorGridToExcelAction.pending, state => {
        state.isDownloading = true
      })
      .addCase(exportVendorGridToExcelAction.fulfilled, state => {
        state.isDownloading = false
      })
      .addCase(exportVendorGridToExcelAction.rejected, state => {
        state.isDownloading = false
      })

      // fetchPickedNLCItems
      .addCase(fetchPickedNLCItems.pending, state => {
        state.isFetchingPickedNLCItems = true
        state.pickedNLCItems = []
        state.pickedNLCItemsCount = 0
      })
      .addCase(fetchPickedNLCItems.fulfilled, (state, action) => {
        state.isFetchingPickedNLCItems = false
        state.pickedNLCItems = action.payload.data.values
        state.pickedNLCItemsCount = action.payload.data.count
      })
      .addCase(fetchPickedNLCItems.rejected, state => {
        state.isFetchingPickedNLCItems = false
        state.pickedNLCItems = []
        state.pickedNLCItemsCount = 0
      })
  },
})

export default vendorsSlice.reducer
